import React from 'react';
import { ProductResult } from 'types';
import './ExpandedTopNav.css';

type ExpandedTopNavProps = {
  productResult: ProductResult;
};
export default function ExpandedTopNav({ productResult }: ExpandedTopNavProps) {
  const resultSummary = productResult.summary;

  return (
    <div className='expanded-top-nav-container'>
      <span
        className={
          resultSummary.includes('Suspected')
            ? 'results-accordion-header-warning'
            : 'results-accordion-header'
        }
      >
        {resultSummary}
      </span>
    </div>
  );
}
